import {IOccasionService} from "../../domain/occasions/IOccasionService";
import {ApiAccessService} from "../api/ApiAccessService";
import {Occasions} from "../../../../../server/src/base/entities/occasion/Occasions";

export class OccasionService implements IOccasionService{

    private apiAccessService:ApiAccessService;

    constructor(apiAccessService:ApiAccessService){
        this.apiAccessService = apiAccessService;
    }

    public Occasions(): Promise<Occasions> {
        return this.apiAccessService.Get("occasion/all", Occasions);
    }

    public Refresh(): Promise<void> {
        return this.apiAccessService.Patch("occasion/update");
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/occasions/OccasionService.ts